import { render, staticRenderFns } from "./Comprehension.vue?vue&type=template&id=e5ea938e&"
import script from "./Comprehension.vue?vue&type=script&lang=js&"
export * from "./Comprehension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports